@if (title) {
<h3 class="mb-1 mw-100" [attr.data-e2e]="e2e + '-title'">{{ title }}</h3>
} @if (subTitle) {
<p class="standard text-mw mb-0" [attr.data-e2e]="e2e + '-subTitle'">{{ subTitle }}</p>
}

<ul class="list" [attr.data-e2e]="e2e + '-items'">
  @for (item of items; track item) {
  <li [innerHTML]="item"></li>
  }
</ul>

@if (caption) {
<p class="standard text-mw p-0 m-0" [attr.data-e2e]="e2e + '-caption'">{{ caption }}</p>
}
